/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Rail_MaxInputs */

const en_ui_rail_max = /** @type {(inputs: Ui_Rail_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`max`)
};

const de_ui_rail_max = /** @type {(inputs: Ui_Rail_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`max`)
};

/**
* | output |
* | --- |
* | "max" |
*
* @param {Ui_Rail_MaxInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_rail_max = /** @type {((inputs?: Ui_Rail_MaxInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Rail_MaxInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_rail_max(inputs)
	return de_ui_rail_max(inputs)
});